export default __webpack_public_path__ + "static/media/logo_autopay.1a916787.png";